export type DohHealthBand = 'critical' | 'at_risk' | 'healthy';

export const DOH_HEALTH = {
  critical: {
    key: 'critical',
    label: 'Critical Items',
    indicatorLabel: 'Critical',
    badge: 'Under 5 DOH',
    badgeClassName: 'bg-red-600 text-white',
    dotClassName: 'bg-red-600',
  },
  at_risk: {
    key: 'at_risk',
    label: 'At Risk Items',
    indicatorLabel: 'At Risk',
    badge: '5-20 DOH',
    badgeClassName: 'bg-amber-500 text-zinc-950',
    dotClassName: 'bg-amber-500',
  },
  healthy: {
    key: 'healthy',
    label: 'Healthy Items',
    indicatorLabel: 'Healthy',
    badge: '21+ DOH',
    badgeClassName: 'bg-sky-600 text-white',
    dotClassName: 'bg-sky-600',
  },
} as const;

export const DOH_CARDS = [DOH_HEALTH.critical, DOH_HEALTH.at_risk, DOH_HEALTH.healthy];

export function getDohHealthBand(doh: number): DohHealthBand {
  if (doh < 5) return 'critical';
  if (doh < 21) return 'at_risk';
  return 'healthy';
}
